/*
 * Discount code on /cart — sections/main-cart-footer.liquid.
 *
 * Every element it touches is server-rendered inside the footer's
 * `.js-contents`, which assets/cart.js replaces after any quantity change.
 * So nothing is bound to a node: all listeners are delegated on `document`,
 * and the only state kept here is whether the field was open and what was
 * typed, so a re-render mid-typing does not swallow the code.
 *
 * One write per attempt (`/cart/update.js` with `discount`). Shopify's bot
 * protection scores repeated discount writes as code probing and answers
 * with a challenge wall, so a rejected code is reported and left alone —
 * the next valid code replaces it anyway.
 */
(function () {
  if (window.sondosCartDiscountInit) return;
  window.sondosCartDiscountInit = true;

  var ROOT = '[data-sondos-cart-discount]';
  var open = false;
  var draft = '';
  var busy = false;

  function root() {
    return document.querySelector(ROOT);
  }

  function shopRoot() {
    return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  }

  function msg(key, code) {
    var el = root();
    var text = (el && el.dataset['msg' + key]) || '';
    return text.replace('[code]', code || '');
  }

  function normalize(value) {
    return String(value || '').trim();
  }

  function setStatus(text, tone) {
    var el = root();
    var status = el && el.querySelector('[data-sondos-cart-discount-status]');
    if (!status) return;
    status.textContent = text || '';
    status.classList.toggle('is-error', tone === 'error');
  }

  // The visually-hidden region in the items section survives every re-render;
  // success and removal are read out from there so the card itself stays clean.
  function announce(text) {
    var live = document.getElementById('cart-live-region-text');
    if (!live || !text) return;
    live.setAttribute('aria-hidden', 'false');
    live.textContent = text;
    window.setTimeout(function () {
      live.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  function setOpen(nextOpen, focus) {
    var el = root();
    if (!el) return;
    var toggle = el.querySelector('[data-sondos-cart-discount-toggle]');
    var form = el.querySelector('[data-sondos-cart-discount-form]');
    var input = el.querySelector('[data-sondos-cart-discount-input]');
    if (!toggle || !form) return;

    var startHeight = form.hidden ? 0 : form.getBoundingClientRect().height;
    var startOpacity = form.hidden ? 0 : getComputedStyle(form).opacity;
    if (form.sondosReveal) {
      form.sondosReveal.cancel();
      form.sondosReveal = null;
    }
    open = Boolean(nextOpen);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    el.classList.toggle('is-open', open);

    // Animate the actual form height; section re-renders restore instantly.
    // Keep focus synchronous with the tap so mobile keyboards still open.
    var animate = focus && form.animate &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    form.hidden = false;
    form.inert = !open;
    if (animate) {
      var targetHeight = open ? form.getBoundingClientRect().height : 0;
      var animation = form.animate([
        { height: startHeight + 'px', opacity: startOpacity, overflow: 'hidden' },
        { height: targetHeight + 'px', opacity: open ? 1 : 0, overflow: 'hidden' }
      ], { duration: 200, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'both' });
      form.sondosReveal = animation;
      animation.onfinish = function () {
        if (form.sondosReveal !== animation) return;
        form.hidden = !open;
        animation.cancel();
        form.sondosReveal = null;
      };
    } else {
      form.hidden = !open;
    }

    if (input && open && draft && !input.value) input.value = draft;
    if (!open) setStatus('');
    if (open && focus && input) input.focus({ preventScroll: true });
  }

  function sectionRequests() {
    var requests = [];
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');

    if (items && items.dataset.id) {
      requests.push({ id: 'main-cart-items', section: items.dataset.id, selector: '.js-contents' });
    }
    if (footer && footer.dataset.id) {
      requests.push({ id: 'main-cart-footer', section: footer.dataset.id, selector: '.js-contents' });
    }
    if (document.getElementById('cart-icon-bubble')) {
      requests.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
    }
    return requests;
  }

  function renderSections(cart, requests) {
    if (!cart || !cart.sections) return;
    requests.forEach(function (request) {
      var container = document.getElementById(request.id);
      var html = cart.sections[request.section];
      if (!container || !html) return;
      var fragment = new DOMParser().parseFromString(html, 'text/html');
      var source = fragment.querySelector(request.selector);
      var target = container.querySelector(request.selector) || container;
      if (source) target.innerHTML = source.innerHTML;
    });
  }

  function writeDiscount(discount, requests) {
    var payload = { discount: discount };
    if (requests.length) {
      payload.sections = requests.map(function (request) { return request.section; });
      payload.sections_url = window.location.pathname;
    }
    return fetch(shopRoot() + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response.text().then(function (text) {
        var cart;
        try {
          cart = JSON.parse(text);
        } catch (e) {
          throw new Error('cart/update.js returned non-JSON (' + response.status + ')');
        }
        if (!response.ok || !cart || typeof cart !== 'object') {
          throw new Error('cart/update.js failed (' + response.status + ')');
        }
        return cart;
      });
    });
  }

  function codeApplied(cart, code) {
    var wanted = normalize(code).toLowerCase();
    var codes = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
    return codes.some(function (entry) {
      return normalize(entry.code).toLowerCase() === wanted && entry.applicable !== false;
    });
  }

  function finish(cart, requests, source) {
    renderSections(cart, requests);
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: { cart: cart, source: source }
    }));
  }

  function apply() {
    var el = root();
    var input = el && el.querySelector('[data-sondos-cart-discount-input]');
    var button = el && el.querySelector('[data-sondos-cart-discount-apply]');
    if (!el || !input || !button || busy) return;

    var code = normalize(input.value);
    if (!code) {
      input.focus();
      return;
    }

    var idleLabel = button.textContent;
    var requests = sectionRequests();

    busy = true;
    button.disabled = true;
    button.textContent = msg('Busy');
    input.setAttribute('aria-invalid', 'false');
    setStatus('');

    writeDiscount(code, requests)
      .then(function (cart) {
        if (!codeApplied(cart, code)) {
          // Rejected: the field stays, the message says why, no second write.
          busy = false;
          button.disabled = false;
          button.textContent = idleLabel;
          input.setAttribute('aria-invalid', 'true');
          setStatus(msg('Invalid'), 'error');
          input.focus();
          input.select();
          return;
        }

        draft = '';
        open = false;
        busy = false;
        finish(cart, requests, 'sondos-cart-discount');
        announce(msg('Applied', code));
        // The submit button she was on no longer exists; keyboard focus lands
        // on the chip's remove control instead of falling to <body>.
        var removeButton = document.querySelector('[data-sondos-cart-discount-remove]');
        if (removeButton) removeButton.focus({ preventScroll: true });
      })
      .catch(function () {
        busy = false;
        var current = root();
        var currentButton = current && current.querySelector('[data-sondos-cart-discount-apply]');
        if (currentButton) {
          currentButton.disabled = false;
          currentButton.textContent = idleLabel;
        }
        setStatus(msg('Error'), 'error');
      });
  }

  function remove(button) {
    var el = root();
    if (!el || busy) return;

    var removed = normalize(button.getAttribute('data-sondos-cart-discount-remove')).toLowerCase();
    // Whatever else is applied stays: the chips are the server's own list.
    var remaining = Array.prototype.map.call(
      el.querySelectorAll('[data-sondos-cart-discount-remove]'),
      function (node) { return normalize(node.getAttribute('data-sondos-cart-discount-remove')); }
    ).filter(function (code) {
      return code && code.toLowerCase() !== removed;
    });

    var requests = sectionRequests();
    busy = true;
    button.disabled = true;
    setStatus('');

    // An explicit removal outranks the auto-apply for the rest of the session,
    // even if she later changes the cart (which would otherwise mint a new key).
    var auto = normalize(el.dataset.autoCode);
    if (auto && auto.toLowerCase() === removed) {
      store(function (s) { s.setItem(optOutKey(auto), '1'); });
    }

    writeDiscount(remaining.join(','), requests)
      .then(function (cart) {
        busy = false;
        finish(cart, requests, 'sondos-cart-discount');
        announce(msg('Removed'));
        var toggle = document.querySelector('[data-sondos-cart-discount-toggle]');
        if (toggle) toggle.focus({ preventScroll: true });
      })
      .catch(function () {
        busy = false;
        button.disabled = false;
        setStatus(msg('Error'), 'error');
      });
  }

  /*
   * Auto-apply (section setting `auto_discount_code`).
   *
   * Three brakes, in order:
   *  1. The server already says a code is on  → nothing to do.
   *  2. She removed one by hand this session  → never re-impose it.
   *  3. This exact cart state was tried before → one write per state, because
   *     Shopify answers repeated discount writes with a bot-challenge wall.
   *
   * Brake 3 is also what makes the × stick without any extra bookkeeping:
   * removing a code restores the same item count and total the page started
   * with, so the key is already spent. Brake 2 exists because adding a product
   * changes that key, and an explicit removal should outlive a cart edit.
   *
   * Silent on failure: she never asked for this, so a code that does not apply
   * is not an error to put in front of her.
   */
  function store(fn, fallback) {
    try { return fn(window.sessionStorage); } catch (e) { return fallback; }
  }

  function autoKey(el, code) {
    return 'snd_cart_auto:' + code.toLowerCase() + ':' + (el.dataset.cartState || '');
  }

  function optOutKey(code) {
    return 'snd_cart_auto_off:' + code.toLowerCase();
  }

  function autoApply() {
    var el = root();
    if (!el || busy) return;
    if (el.classList.contains('is-applied')) return;

    var code = normalize(el.dataset.autoCode);
    if (!code) return;
    if (open || draft) return;
    if (store(function (s) { return s.getItem(optOutKey(code)); }, null) === '1') return;

    var key = autoKey(el, code);
    if (store(function (s) { return s.getItem(key); }, null) === '1') return;
    store(function (s) { s.setItem(key, '1'); });

    var requests = sectionRequests();
    busy = true;
    writeDiscount(code, requests)
      .then(function (cart) {
        busy = false;
        if (!codeApplied(cart, code)) return;
        finish(cart, requests, 'sondos-cart-discount');
        announce(msg('Applied', code));
      })
      .catch(function () { busy = false; });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-sondos-cart-discount-toggle]');
    if (toggle) {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true', true);
      return;
    }
    var removeButton = event.target.closest('[data-sondos-cart-discount-remove]');
    if (removeButton) remove(removeButton);
  });

  document.addEventListener('submit', function (event) {
    if (!event.target.closest || !event.target.closest('[data-sondos-cart-discount-form]')) return;
    event.preventDefault();
    apply();
  });

  document.addEventListener('input', function (event) {
    if (!event.target.matches || !event.target.matches('[data-sondos-cart-discount-input]')) return;
    draft = event.target.value;
    if (event.target.getAttribute('aria-invalid') === 'true') {
      event.target.setAttribute('aria-invalid', 'false');
      setStatus('');
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (!event.target.matches || !event.target.matches('[data-sondos-cart-discount-input]')) return;
    setOpen(false);
    var toggle = document.querySelector('[data-sondos-cart-discount-toggle]');
    if (toggle) toggle.focus();
  });

  // A quantity change re-rendered the card: put the field back the way it was,
  // then re-check auto-apply against the cart state the server just rendered.
  document.addEventListener('cart:updated', function (event) {
    if (event.detail && event.detail.source === 'sondos-cart-discount') return;
    if (open) setOpen(true, false);
    autoApply();
  });

  autoApply();
})();
